import useSelector from '../../redux/typedHooks';
import { useDocumentData } from './useDocumentData';
import { DocumentTypeLabel } from '../../../../types/testType';
import { resolveDocumentUrl, appendUrlModifiers } from './useDocumentUrl.utils';
import type { DocumentData, QueryParam } from './useDocumentUrl.types';

export { resolveDocumentUrl } from './useDocumentUrl.utils';

const useResolveDataUrl = (data?: DocumentData, anchorId?: string, queryParams?: QueryParam[]): string | undefined => {
  const { mappedCategories } = useSelector((state) => state.sitestructure);

  let href = resolveDocumentUrl(data, mappedCategories);

  if (
    data?.type === DocumentTypeLabel.nafnoProductArticle &&
    data.parent?.type === DocumentTypeLabel.nafnoSiteStructure &&
    data.parent?.slug &&
    href
  ) {
    href = `/${data.parent.slug}${href}`;
  }

  return appendUrlModifiers(href, queryParams, anchorId);
};

export const useDocumentUrl = (slug: string): string | undefined => {
  const { data } = useDocumentData(slug);
  return useResolveDataUrl(data);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useDocumentUrlWithNode = (data: any, anchorId?: string, queryParams?: QueryParam[]): string | undefined =>
  useResolveDataUrl(data, anchorId, queryParams);
